
/**
 * Utility functions for handling navigation and scrolling behavior
 */

/**
 * Scrolls the window to the top of the page
 * @param behavior - The scroll behavior (smooth or auto)
 */
export const scrollToPageTop = (behavior: ScrollBehavior = 'smooth'): void => {
  window.scrollTo({
    top: 0,
    behavior
  });
};

/**
 * Handles the click event for navigation links that need page scroll reset
 */
export const handleScrollReset = (): void => {
  // Using setTimeout to ensure the scroll happens after navigation
  setTimeout(() => {
    scrollToPageTop();
  }, 100);
};
